import(/* webpackMode: "eager" */ "/app/public/building.png");
;
import(/* webpackMode: "eager" */ "/app/public/cifra.png");
;
import(/* webpackMode: "eager" */ "/app/public/cookie.png");
;
import(/* webpackMode: "eager" */ "/app/public/donuts.png");
;
import(/* webpackMode: "eager" */ "/app/public/factory.png");
;
import(/* webpackMode: "eager" */ "/app/public/flowers.png");
;
import(/* webpackMode: "eager" */ "/app/public/vehicle.png");
;
import(/* webpackMode: "eager" */ "/app/public/wheat.png");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/cases/[case]/_components/Article10/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/cases/[case]/_components/Article2/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/cases/[case]/_components/Article3/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/cases/[case]/_components/Article5/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/cases/[case]/_components/Article6/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/cases/[case]/_components/Article7/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/cases/[case]/_components/Article8/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/cases/[case]/_components/Article9/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/cases/[case]/_components/ArticleImages/index.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/Typography/styles.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/Button/styles.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/app/cases/[case]/styles.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/Icon/styles.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/components/Link/styles.module.css");
;
import(/* webpackMode: "eager" */ "/app/src/icons/analytics.svg");
;
import(/* webpackMode: "eager" */ "/app/src/icons/behance.svg");
;
import(/* webpackMode: "eager" */ "/app/src/icons/burger-menu.svg");
;
import(/* webpackMode: "eager" */ "/app/src/icons/check-mark.svg");
;
import(/* webpackMode: "eager" */ "/app/src/icons/close.svg");
;
import(/* webpackMode: "eager" */ "/app/src/icons/down-arrow.svg");
;
import(/* webpackMode: "eager" */ "/app/src/icons/drop-down.svg");
;
import(/* webpackMode: "eager" */ "/app/src/icons/dzen.svg");
;
import(/* webpackMode: "eager" */ "/app/src/icons/eye.svg");
;
import(/* webpackMode: "eager" */ "/app/src/icons/instagram.svg");
;
import(/* webpackMode: "eager" */ "/app/src/icons/left-arrow.svg");
;
import(/* webpackMode: "eager" */ "/app/src/icons/link.svg");
;
import(/* webpackMode: "eager" */ "/app/src/icons/mail.svg");
;
import(/* webpackMode: "eager" */ "/app/src/icons/pdf.svg");
;
import(/* webpackMode: "eager" */ "/app/src/icons/right-arrow.svg");
;
import(/* webpackMode: "eager" */ "/app/src/icons/task-check.svg");
;
import(/* webpackMode: "eager" */ "/app/src/icons/telegram.svg");
;
import(/* webpackMode: "eager" */ "/app/src/icons/unread.svg");
;
import(/* webpackMode: "eager" */ "/app/src/icons/up-right-arrow.svg");
;
import(/* webpackMode: "eager" */ "/app/src/icons/upload.svg");
;
import(/* webpackMode: "eager" */ "/app/src/icons/user.svg");
;
import(/* webpackMode: "eager" */ "/app/src/icons/vc.svg");
;
import(/* webpackMode: "eager" */ "/app/src/icons/vk.svg");
